import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectFromSSOData = createFeatureSelector<boolean>('fromSSO');

export const selectFromSSOState = createSelector(
    selectFromSSOData,
    (state: boolean) => state,
);
